<script>
  import FormInput from '../FormControls/FormInput.svelte';
  export let form;
  export let errors;
  export let handleChange;

  function addContact() {
    let arr = $form.contacts;
    arr.push({ name: '', email: '', title: '', phone: '', new: 1 });
    $form.contacts = arr;
  }

  $: if ($form.contacts.length == 0) {
    addContact();
  }

  const removeContact = (key) => {
    let arr = $form.contacts;
    arr.splice(key, 1);
    $form.contacts = arr;

    let errorArr = $errors.contacts;
    errorArr.splice(key, 1);
    $errors.contacts = errorArr;
  };
</script>

<div class="p-3 h-100">
  <div class="profile-content mx-auto">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>Client Contacts </span></h3>
    </div>
  </div>

  <div class="profile-content mx-auto h-100">
    <div class="row mb-2">
      <div class="col">
        <label
          for=""
          class="form-label">Contact Name(s)</label
        >
      </div>
      <div class="col">
        <label
          for=""
          class="form-label">Title</label
        >
      </div>

      <div class="col">
        <label
          for=""
          class="form-label">Email</label
        >
      </div>
      <div class="col">
        <label
          for=""
          class="form-label"
          >Phone No
        </label>
      </div>

      <div class="col add-btn-col" />
    </div>

    {#each $form.contacts as contact, i}
      <div class="row mt-3">
        <div class="col">
          <FormInput
            name={`contacts[${i}].name`}
            type="text"
            placeholder="Enter Contact Name(s)"
            error={$errors.contacts[i] != undefined ? $errors.contacts[i].name : undefined}
            bind:value={$form.contacts[i].name}
            handleChange={handleChange}
          />
        </div>
        <div class="col">
          <div class="form-group">
            <FormInput
              name={`contacts[${i}].title`}
              placeholder="Enter Title"
              error={$errors.contacts[i] != undefined ? $errors.contacts[i].title : undefined}
              bind:value={$form.contacts[i].title}
              handleChange={handleChange}
            />
          </div>
        </div>
        <div class="col">
          <FormInput
            name={`contacts[${i}].email`}
            type="email"
            placeholder="Enter Email"
            error={$errors.contacts[i] != undefined ? $errors.contacts[i].email : undefined}
            bind:value={$form.contacts[i].email}
            handleChange={handleChange}
          />
        </div>
        <div class="col">
          <div class="form-group">
            <FormInput
              name={`contacts[${i}].phone`}
              type="text"
              placeholder="Enter Phone No."
              error={$errors.contacts[i] != undefined ? $errors.contacts[i].phone : undefined}
              bind:value={$form.contacts[i].phone}
              handleChange={handleChange}
            />
          </div>
        </div>
      </div>
      <hr />
      <div class="d-flex justify-content-end flex-column align-items-end">
        {#if i === 0}
          {#if $form.contacts.length == 1 && $form.contacts[i].new == undefined}
            <button
              class="btn btn-link px-0 mb-0 box-shadow-none border-0 bg-transparent font-size-12 color-red shadow-none"
              on:click={() => removeContact(i)}
            >
              <img
                alt=""
                class="icon-16 me-1"
                src="/images/trash.svg"
              /> Clear
            </button>
          {/if}
          <button
            on:click={() => addContact()}
            class="btn btn-link px-0 mb-0 bg-transparent box-shadow-none border-0 font-size-12 shadow-none"
          >
            <img
              class="icon-10"
              alt=""
              src="/images/plus.svg"
            /> Add More
          </button>
        {:else}
          <button
            class="btn btn-link px-0 mb-0 box-shadow-none border-0 bg-transparent font-size-12 color-red shadow-none"
            on:click={() => removeContact(i)}
          >
            <img
              alt=""
              class="icon-16 me-1"
              src="/images/trash.svg"
            /> Remove
          </button>
        {/if}
      </div>
    {/each}
  </div>
</div>
